import React, { useEffect, useState } from 'react';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState(2 * 60 * 60); // 2 hours in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor(seconds % 3600 / 60);
    const secs = seconds % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  return <div className="fixed top-0 left-0 right-0 z-50 h-[32px] bg-gradient-to-r from-coralOrange to-softViolet flex items-center justify-center px-4" data-id="element-204">
      <p className="text-white font-bold text-xs md:text-sm flex items-center gap-2" data-id="element-205">
        <span data-id="element-206">⏰ Oferta por tiempo limitado:</span>
        <span className="text-goldenYellow font-bold text-sm md:text-base tracking-wider" data-id="element-207">
          {formatTime(timeLeft)}
        </span>
      </p>
    </div>;
}